module.exports = __webpack_public_path__ + "img/Moodboard.26b498fe.png";